// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}\n._1bahesu3{justify-content:flex-end}\n._1e0c1txw{display:flex}\n._pof3u2gc>*+*{margin-left:var(--ds-space-100,8px)}", ""]);
// Exports
module.exports = exports;
